<template>
  <div>
    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submit)">
        <div class="form-group row">
          <reg-input-text
            v-if="fields[0]"
            label="First Name"
            :form="form"
            :field="fields[0]"
            placeholder="Enter First Name"
            :api-errors="apiErrors"
            formGroupClass="col-xxl-6 col-xl-6 col-lg-6 col-md-6 mb-3"
            :rules="{ required: fields[1].required }"
          />
          <reg-input-text
            v-if="fields[1]"
            label="Last Name"
            :form="form"
            :field="fields[1]"
            placeholder="Enter Last Name"
            :api-errors="apiErrors"
            formGroupClass="col-xxl-6 col-xl-6 col-lg-6 col-md-6 mb-3"
            :rules="{ required: fields[2].required }"
          />

          <div class="col-md-12">
            <reg-input-text
              v-if="fields[3]"
              label="Mobile Number"
              inputType="text"
              :form="form"
              :field="fields[3]"
              placeholder="Enter Mobile Number"
              formGroupClass=""
              :rules="{ required: fields[3].required, digits: 10 }"
              maxlength="10"
              inputmode="numeric"
              pattern="\d*"
              @keypress.native="onlyAllowDigitsPhone($event)"
            />
            <!--:api-errors="apiErrors"-->
            <div class="d-flex justify-content-between validation-row mt-2 mb-2 flex-wrap"
              :class="showOtpSectionPhone ? 'grp-contact-otp-validation col-md-8 col-sm-11 mb-3' : 'mb-2'"
            >
              <!-- <div class="skip-email-verify p-0 col-md-7 col-sm-6 d-flex align-items-center">
                <input type="checkbox" name="skip-verification" class="mr-2"/>
                <label>Skip Verification</label>
              </div> -->
              <a
                v-if="showOtpSectionPhone"
                href="#"
                class="validate-via-otp-link validate-btn p-0"
                @click.prevent="openOtpModal('phone', form[fields[3].field_name])"
              >
                TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR PHONE.
              </a>
              <!-- <span >Validating...</span> -->
            </div>

            <!-- to show the error message dynamically under the fields -->
            <div v-if="phoneMsg" class="contacts-message-container form-group">
              <div :class="['validate-message mt-2', phoneValidationMessage.type]">
                <div
                  :class="['message-indicator', `${phoneValidationMessage.type}-indicator`]"
                ></div>
                <span class="message-text">
                  <strong :class="`${phoneValidationMessage.type}-text`">
                    {{ phoneValidationMessage.title }}
                  </strong>
                  -
                  {{ phoneValidationMessage.message }}
                </span>
              </div>
            </div>

            <!-- <button
              @click="openModal(fields[3].field_name)"
              class="button-verify-email"
              v-if="apiErrors && apiErrors[fields[3].field_name]"
            >
              Verify Your Phone Number
            </button> -->
          </div>

          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 mb-3">
            <reg-input-text
              v-if="fields[2]"
              label="Contact Title"
              :form="form"
              :field="fields[2]"
              placeholder="Enter Contact Title"
              :api-errors="apiErrors"
              formGroupClass=""
              :rules="{ required: fields[2].required }"
            />
          </div>
          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 mb-4">
            <reg-input-text
              v-if="fields[4]"
              label="FAX Number"
              type="number"
              :form="form"
              :field="fields[4]"
              placeholder="Enter FAX Number"
              :api-errors="apiErrors"
              formGroupClass="w-100"
              :rules="{ required: fields[4].required, digits: 10 }"
              maxlength="10"
              inputmode="numeric"
              pattern="\d*"
              @keypress.native="onlyAllowDigitsFax($event)"
            />
          </div>
        </div>
        <div class="action-btn split-action mt-3">
          <button class="button-black" @click="backHandler" type="button">Back</button>
          <div class="action-next">
            <button class="button-green" @click.prevent="saveAndContinue" type="button">
              Save & Continue Later
            </button>
            <button class="button-blue" type="submit">Next</button>
          </div>
        </div>
      </form>
      <otp-verification-modal
        v-if="showOtpModal"
        v-model="showOtpModal"
        :identifier="contactInfo"
        :identifierTypeText="otpType"
        :field="field"
        @save="handleVerificationResult"
        @close="closeOtpModal"
      />
    </ValidationObserver>
    <!-- <verify-phone-email-modal inputType="phone" /> -->
    <!-- <verify-phone-email-modal :inputType="inputType" :inputValue="inputValue"/> -->
  </div>
</template>
<script>
  import Cookies from 'js-cookie';
  import axios from '@/utils/regAxios';
  import Screenshot from '@/utils/screenshot';
  // import VerifyPhoneEmailModal from "../../Member/modal/VerifyPhoneEmailModal.vue";
  import OtpVerificationModal from '@/components/common/OtpVerificationModal.vue';

  export default {
    name: 'ContactForm',
    components: {
      // VerifyPhoneEmailModal,
      OtpVerificationModal,
    },
    props: {
      fields: {
        required: true,
      },
      form: {
        required: true,
      },
    },
    data: () => ({
      apiErrors: null,
      inputType: null,
      inputValue: null,
      showOtpModal: false,
      otpFieldType: null,
      otpFieldValue: null,
      contactInfo: null,
      otpType: null,
      field: null,
      phoneMsg: false,

      phoneValidationMessage: null,
      showOtpSectionPhone: false,
    }),
    methods: {
      onlyAllowDigitsPhone(event) {
        const key = event.key;
        // Allow: backspace, delete, tab, escape, enter, arrows, home, end
        if (
          [46, 8, 9, 27, 13, 37, 38, 39, 40, 35, 36].includes(event.keyCode) ||
          // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
          (event.ctrlKey === true && [65, 67, 86, 88].includes(event.keyCode))
        ) {
          return;
        }
        // Ensure it's a number and not more than 9 digits
        if (!/^\d$/.test(key) || event.target.value.length >= 10) {
          event.preventDefault();
        }
      },
  onlyAllowDigitsFax(event) {
        const key = event.key;
        // Allow: backspace, delete, tab, escape, enter, arrows, home, end
        if (
          [46, 8, 9, 27, 13, 37, 38, 39, 40, 35, 36].includes(event.keyCode) ||
          // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
          (event.ctrlKey === true && [65, 67, 86, 88].includes(event.keyCode))
        ) {
          return;
        }
        // Ensure it's a number and not more than 9 digits
        if (!/^\d$/.test(key) || event.target.value.length >= 10) {
          event.preventDefault();
        }
      },
      removeTimer() {
        Cookies.remove('otp_logged_time');
      },

      checkCookies() {
        if (Cookies.get('otp_logged_time') !== undefined) {
          return true;
        } else {
          return false;
        }
      },

      getTimer() {
        if (this.checkCookies()) {
          // this.$notify('Please wait for 10 minutes before sending another OTP', 'error')
          return false;
        }

        let cookieValue = Cookies.get('otp_logged_time');
        let remaining = Math.round((cookieValue - new Date().getTime()) / 1000);

        this.remaningSecond = isNaN(remaining) ? 0 : remaining;

        if (remaining) {
          // this.$notify('Please wait for 10 minutes before sending another OTP', 'error')
          return false;
        } else {
          // this.$notify('otp can be send now', 'success');
          return true;
        }
      },

      handleVerificationResult(result) {
        if (result.verified) {
          // Handle successful verification
          if (result.type === 'phone' && result.field === 'phone') {
            this.phoneMsg = true;
            this.skipPhoneVerification = true;
            this.form.skip_validation_phone = 1;
            this.phoneValidationMessage = {
              type: 'success',
              title: 'Success',
              message: 'Your phone has been verified!',
            };
            this.showOtpSectionPhone = false;
          }
        }
      },

      async sendOtp() {
        if (!this.getTimer()) {
          // this.$notify('Please wait for 10 minutes before sending another OTP', 'error')
          return;
        }

        try {
          let url = process.env.VUE_APP_API_URL_V2 + `send-group-otp`;
          axios
            .post(url, {
              contact: this.contactInfo,
              enrollment_id: this.$store.getters.regTempId,
              type: this.otpType,
            })

            .then((res) => {
              if (res.data.success === true || res.data.status === 'success') {
                this.$notify('OTP sent successfully!');
              } else {
                this.$notify(res.data.message || 'Failed to send OTP. Please try again.', 'error');
                // this.showOtpSection = false;
              }
            })

            .catch((err) => {
              this.$notify(err.response.data.message, 'error');
            });
        } catch (error) {
          this.$notify('Failed to send OTP. Please try again.', 'error');
          // this.showOtpSection = false;
          console.error('OTP send error:', error);
        }
      },

      openOtpModal(type, phone) {
        if (type === 'mobile' && !phone) {
          this.$notify('Please enter mobile number first.', 'warning');
          return;
        }
        if (type === 'phone') {
          this.field = 'phone';
          this.contactInfo = phone;
          this.otpType = type;
          this.sendOtp();
        }
        // this.contactInfo = type === "email" ? this.form.email : this.form.cell_phone;
        this.showOtpModal = true;
      },

      // to close the otp modal
      closeOtpModal() {
        this.showOtpModal = false;
      },

      saveAndContinue() {
        this.$emit('onOpenSaveAndContinue', this.form);
      },
      backHandler() {
        this.$emit('onBackHandler');
      },
      async submit() {
        this.form.registration_id = this.$store.getters.regTempId;
        let loader = this.$loading.show();
        let formData = this.form;
        Screenshot.captureScreenShot(Screenshot.regScreenShotSelector)
          .then((res) => {
            if (res) {
              formData['screenshot'] = res;
            }
          })
          .finally(() => {
            loader.hide();
            const url = 'register/contact-info';
            this.save(url, formData);
          });
      },
      // openModal(fieldName, email) {
      //   this.$bvModal.show("verifyEmailPhoneModal");
      //   this.contact = email;
      //   if (this.apiErrors && this.apiErrors[fieldName]) {
      //     this.$set(this.apiErrors, fieldName, null);
      //   }
      //   // Dynamically set inputType and inputValue
      //   this.inputType = fieldName;
      //   this.inputValue = this.form[fieldName]; // Get the correct field value dynamically
      // },

      async save(url, payload) {
        this.phoneMsg = false;
        this.showOtpSectionPhone = false;
        this.phoneValidationMessage = null;

        let loader = this.$loading.show();
        try {
          let res = await axios.post(url, payload);
          if (res.data.statusCode == 200) {
            this.$emit('onSuccess');
            this.removeTimer();
            this.form.skip_validation_phone = 0;
          }
        } catch (err) {
          this.removeTimer();

          if (err.response.data.statusCode == 422) {
            this.apiErrors = err.response.data.errors;
            if (this.apiErrors.phone) {
              this.skipPhoneVerification = false;
              this.phoneMsg = true;
              let notificationMessage = '';
              if (this.apiErrors.phone.includes('The phone has already been taken.')) {
                this.phoneValidationMessage = {
                  type: 'error',
                  title: 'Caution',
                  message: 'Phone is already in use',
                };
                notificationMessage = 'The Phone Number is already in use';
              } else {
                this.showOtpSectionPhone = true;
                this.phoneValidationMessage = {
                  type: 'error',
                  title: 'Caution',
                  message: 'Invalid Phone - Please validate via OTP',
                };
                notificationMessage = 'Invalid Phone - Please validate via OTP';
              }
              this.$notify(notificationMessage, 'error');
            }

            // setTimeout(() => {
            //   this.apiErrors = null;
            // }, 5000);
            // setTimeout(() => {
            //     if (this.apiErrors && this.fields && this.fields.length > 0) {
            //       const fieldsToKeep = [
            //         this.fields[3].field_name,
            //       ];

            //       const newErrors = { ...this.apiErrors };

            //       // Remove errors for all fields except fields[3]
            //       Object.keys(newErrors).forEach((key) => {
            //         if (!fieldsToKeep.includes(key)) {
            //           delete newErrors[key];
            //         }
            //       });

            //       this.apiErrors = Object.keys(newErrors).length
            //         ? newErrors
            //         : null;
            //     }
            //   }, 5000);
          } else {
            this.$notify('something went wrong, Please try again later', 'error');
          }
        } finally {
          loader.hide();
        }
      },
    },
    created() {
      this.removeTimer();
      if (!this.$store.getters.regTempId) {
        this.backHandler();
      }
    },

    watch: {
      'form.phone': {
        handler(newVal, oldVal) {
          if (newVal !== oldVal) {
            this.form.skip_validation_phone = 0;
            this.removeTimer();
            this.phoneMsg = false;
            this.showOtpSectionPhone = false;
            this.phoneValidationMessage = null;
            this.phoneVerified = false;
          }
        },
        immediate: true, // To capture initial value
      },
    },
  };
</script>
<style>
  .validate-message {
    display: flex;
    align-items: center;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    padding: 0.75rem 1rem;
    position: relative;
    margin-bottom: 0.75rem;
  }

  .message-indicator {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  .message-text {
    flex-grow: 1;
    margin-left: 0.5rem;
    color: #495057;
  }

  .error-text {
    color: #dc3545;
    font-size: 0.875rem !important;
  }

  .success-text {
    color: #28a745;
  }

  .warning-text {
    color: #856404;
  }

  .error-indicator {
    background-color: #dc3545;
  }

  .success-indicator {
    background-color: #28a745;
  }

  .warning-indicator {
    background-color: #ffc107;
  }

  .button-verify-email {
    margin-top: 0;
    margin-bottom: 5px;
    font-size: 16px;
    border: none;
    background-color: transparent;
    color: rgb(5, 5, 139);
    text-decoration: underline;
    text-align: start;
  }

  .grp-contact-otp-validation {
    border: 2px solid #e31717;
    padding: 5px;
    padding-left: 15px;
  }
  .grp-contact-otp-validation:hover {
    border: 2px solid #a50e0e;
    box-shadow: #eb2a2a;
    background-color: aliceblue;
    cursor: pointer;
  }
</style>
